import { uploadFileToS3 } from '@/utils/s3Utils';

(function () {
    'ngInject';

    angular.module('app.shared.services').service('VectorUtilService', vectorUtilsService);

    function vectorUtilsService(VectorAPIService) {
        /**
         * Upload the given vector file to S3
         * @param {File} vectorFile vector to upload to S3
         * @param {'base' | 'vector'} type type of vector that will be uploaded
         * @param {boolean} includeDimensions wether to include vector dimensions in the result or not
         * @param {boolean} generateThumb wether to generate a thumbnail from the vector or not
         * @param {Function} progressCallback function that reports file upload progress
         */
        async function uploadVectorToS3(vectorFile, type, includeDimensions, generateThumb, progressCallback) {
            // Get signed URL
            const response = await VectorAPIService.getVectorUploadS3SignedUrl(type, vectorFile.name || '');
            // Upload to S3
            await uploadFileToS3(response.SignedUrl, response.Mime, vectorFile, null, (progress) => {
                if (progressCallback) progressCallback('upload', progress);
            });
            // Validate the vector file
            if (progressCallback) progressCallback('process', 0);
            const validationResponse = await VectorAPIService.validateVectorFile(
                type,
                response.Name,
                includeDimensions,
                generateThumb
            );
            if (progressCallback) progressCallback('process', 100);
            return validationResponse;
        }

        function buildVectorPlaceholderProperties({ canvas, canvasWidth, canvasHeight, id, uuid }, override = {}) {
            return {
                strokeWidth: canvas.getVisibleStrokeWidth(),
                strokeDashArray: canvas.getDashedArray(),
                width: 0.3 * canvasWidth,
                height: 0.3 * canvasHeight,
                left: canvasWidth / 2,
                top: canvasHeight / 2,
                allowUserUpload: true,
                lockSkewingX: true,
                lockSkewingY: true,
                applyColoring: false,
                id,
                uuid,
                isOverlay: false,
                isPrintArea: false,
                pageEpsId: canvas.getFirstActivePageEpsId(),
                ...override
            };
        }

        async function getSvgPathFromEpsFile(vectorFile, progressCallback) {
            // Get signed URL
            const response = await VectorAPIService.getVectorUploadS3SignedUrl('vector', vectorFile.name || '');
            // Upload to S3
            await uploadFileToS3(response.SignedUrl, response.Mime, vectorFile, null, (progress) => {
                if (progressCallback) progressCallback('upload', progress);
            });

            // Process the EPS file and get the path to the SVG file from it
            if (progressCallback) progressCallback('process', 0);
            const svgResponse = await VectorAPIService.epsFileToSvgString(response.Name);
            if (progressCallback) progressCallback('process', 100);
            return svgResponse;
        }

        function createEPSSolidBg(width = 1000, height = 1000, fill = '#B69AF2') {
            return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">
                    <rect width="${width}" height="${height}" fill="${fill}"/>
                </svg>
            `;
        }

        return {
            uploadVectorToS3: uploadVectorToS3,
            createEPSSolidBg: createEPSSolidBg,
            getSvgPathFromEpsFile: getSvgPathFromEpsFile,
            buildVectorPlaceholderProperties: buildVectorPlaceholderProperties
        };
    }
})();
